import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'pacienteExamenFtn':  
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_examen', 
									tablaPost: ['datos_pacientes','info_examens','examen_antecedentes','examen_diagnosticos','examen_pruebas',]
								}
							}) 
							break;						
					}
				}

				await this.save(event.save)
				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'pacienteExamenFtn':  
							this.updateDataGet({index: this.indexData, data: this.dataForm[this.namePath]})
						break;
					}
				}

				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}					
		},
		actives(index){
			this.active=[false,false,false,false]
			this.active[index]=true;
		  }		
	},
}